<template>
  <div class="pagination-container">
    <el-pagination
      :background="background"
      :total="total"
      :page-size="15"
      :current-page.sync="currentPage"
      :pager-count="pagerCounter"
      @current-change="handleCurrentChange"
    />
  </div>
</template>

<script>
export default {
  name: "Pagination",
  props: {
    background: {
      type: Boolean,
      default: true
    },
    total: {
      type: Number
    },
    pagerCounter: {
      type: Number,
      default: 5
    },
    page: {
      type: Number,
      default: 1
    }
  },
  computed: {
    currentPage: {
      get() {
        return this.page;
      },
      set(val) {
        this.$emit("update:page", val);
      }
    }
  },
  methods: {
    handleCurrentChange(val) {
      this.$emit("pagination", { page: val });
    }
  }
};
</script>


<style rel="stylesheet/scss" lang="scss" scope>
.el-pagination__rightwrapper {
  float: none;
  display: inline-block;
}
.pagination-container.hidden {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Pagination/index.vue